import styled from 'styled-components';
import { FormLabel } from '@sdk/components/ui/modalForm/modalForm.styles';
import Row from '@sdk/components/ui/spacing/Row';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

type MainProps = {
  backgroundThemeColor?: ThemeColorType;
};

export const Container = styled.div<MainProps>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  background-color: ${({ theme, backgroundThemeColor }) =>
    backgroundThemeColor ? theme.colors[backgroundThemeColor] : 'transparent'};
  display: flex;
  gap: 10px;
  padding: 12px 0;
`;

export const Label = styled(FormLabel)`
  width: 168px;
`;

export const Value = styled(Row)`
  align-items: center;
  color: ${({ theme }) => theme.colors.gray};
`;
